/* unplugin-vue-components disabled */import script from "./AdsPictures.vue?vue&type=script&setup=true&lang=js"
export * from "./AdsPictures.vue?vue&type=script&setup=true&lang=js"

import "./AdsPictures.vue?vue&type=style&index=0&id=1433d08d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1433d08d"]])

export default __exports__